import { Box } from '@mui/material'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

interface IChartLegendItem {
	color: string
	description: string
}

interface IChartLegendProps {
	initialLegends: IChartLegendItem[]
}

const ChartLegend = (props: IChartLegendProps) => {
	const { initialLegends } = props
	return (
		<Box display={'flex'} flexDirection={'row'} gap={'16px'}>
			{initialLegends.map((el, index) => (
				<Box
					key={index}
					display={'flex'}
					flexDirection={'row'}
					gap={'8px'}
					alignItems={'center'}
				>
					<span
						style={{
							backgroundColor: el.color,
							width: '16px',
							height: '16px',
							borderRadius: '50%',
						}}
					></span>
					<TypographySecondary>{el.description}</TypographySecondary>
				</Box>
			))}
		</Box>
	)
}

export default ChartLegend
